/* @jsxImportSource @emotion/react */

import React from 'react'
import { css } from '@emotion/react'

import { navItemBaseCSS } from './styles'

const linkCSS = css`
  ${navItemBaseCSS};
  text-decoration: none;
  transition: background 0.15s ease;
  &:hover {
    background: #f9efe4;
  }
  /* Inverted bar (over a dark hero): translucent white instead of cream. */
  .navbar-inverted &:hover {
    background: rgba(255, 255, 255, 0.16);
  }
`

type Props = {
  href: string
  children: React.ReactNode
}

export const NavMenuLink = ({ href, children }: Props) => (
  <a href={href} css={linkCSS} className="shade-05">
    {children}
  </a>
)
